import React from 'react';
import classNames from 'classnames';
import { Search as SearchIcon } from 'lucide-react';
import Input from 'src/shared/components/input/Input';
import fieldStyles from './ProjectSearchField.module.scss';

export type ProjectSearchFieldProps = {
    label: string;
    placeholder: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    showIcon?: boolean;
    className?: string;
    labelClassName?: string;
    inputClassName?: string;
    testId?: string;
    /** Optional test id for the visible label (avoids ambiguous getByText in e2e). */
    labelTestId?: string;
    type?: React.HTMLInputTypeAttribute;
};

const ProjectSearchField = (props: ProjectSearchFieldProps) => {
    const {
        label,
        placeholder,
        value,
        onChange,
        showIcon = false,
        className,
        labelClassName,
        inputClassName,
        testId,
        labelTestId,
        type = 'text',
    } = props;

    return (
        <div className={className} data-testid={testId}>
            <label className={labelClassName} data-testid={labelTestId}>
                {label}
            </label>
            {showIcon ? (
                <div className={fieldStyles.inputWithIconWrap}>
                    <span className={fieldStyles.searchIcon} aria-hidden>
                        <SearchIcon />
                    </span>
                    <Input
                        type={type}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        className={classNames(inputClassName, fieldStyles.searchInputWithPadding)}
                    />
                </div>
            ) : (
                <Input type={type} value={value} onChange={onChange} placeholder={placeholder} className={inputClassName} />
            )}
        </div>
    );
};

export default ProjectSearchField;
